/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

/* Add-on lines follow their product: when an item is removed, its add-on lines are removed with it. */
(function () {
  function syncAddons(item) {
    if (!item) return;
    const parent = item.querySelector('.cart-item__quantity-input:not([data-addon-of])');
    if (parent && parent.value === '0') {
      item.querySelectorAll('[data-addon-of]').forEach((el) => {
        el.value = '0';
      });
    }
  }
  document.addEventListener('click', (evt) => {
    const hit = evt.target.closest ? evt.target.closest('.cart-item__remove, .quantity-down') : null;
    if (hit) syncAddons(hit.closest('.cart-item'));
  });
  document.addEventListener('change', (evt) => {
    const hit = evt.target.closest ? evt.target.closest('.cart-item__quantity-input') : null;
    if (hit) syncAddons(hit.closest('.cart-item'));
  });
})();

/* The options app adds add-on lines a moment after the main item. Once cart requests settle, refresh the drawer so the lines and prices appear without a page reload. */
(function () {
  if (window.tycDrawerSettle) return;
  window.tycDrawerSettle = true;
  var timer = null;
  var pattern = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function refreshDrawer() {
    var form = document.querySelector('cart-drawer cart-form');
    if (form && typeof form.refresh === 'function') form.refresh();
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refreshDrawer, 900);
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : input && input.url;
      var p = nativeFetch.apply(this, arguments);
      if (url && pattern.test(url)) {
        p.then(schedule, function () {});
      }
      return p;
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && pattern.test(url)) {
      this.addEventListener('loadend', schedule);
    }
    return nativeOpen.apply(this, arguments);
  };
})();

/* Add-on lines follow the jacket quantity. Drawer contents arrive as injected HTML, where inline scripts do not run, so the scaling lives here and runs on every page. Each add-on keeps its per-jacket quantity: raising the jacket from 1 to 2 raises each add-on from 1 to 2. */
(function () {
  if (window.tycAddonScale) return;
  window.tycAddonScale = true;
  function linkQty(hit) {
    if (!hit || !hit.getAttribute) return null;
    var m = (hit.getAttribute('href') || '').match(/[?&]quantity=(\d+)/);
    return m ? parseInt(m[1], 10) : null;
  }
  function scaleAddons(item, hit) {
    if (!item) return;
    var parent = item.querySelector('.cart-item__quantity-input:not([data-addon-of])');
    if (!parent) return;
    var addons = item.querySelectorAll('[data-addon-of]');
    if (!addons.length) return;
    var parentStart = parseInt(parent.getAttribute('data-initial-value'), 10) || 1;
    var parentNow = linkQty(hit);
    if (parentNow === null) parentNow = parseInt(parent.value, 10);
    if (isNaN(parentNow) || parentNow < 0) return;
    addons.forEach(function (el) {
      var addonStart = parseInt(el.getAttribute('data-initial-value'), 10) || 0;
      el.value = String(Math.round((addonStart * parentNow) / parentStart));
    });
  }
  document.addEventListener('click', function (evt) {
    var hit = evt.target.closest ? evt.target.closest('.cart-item__remove, .quantity-down, .quantity-up') : null;
    if (hit) scaleAddons(hit.closest('.cart-item'), hit);
  }, true);
  document.addEventListener('change', function (evt) {
    var hit = evt.target.closest ? evt.target.closest('.cart-item__quantity-input:not([data-addon-of])') : null;
    if (hit) scaleAddons(hit.closest('.cart-item'), null);
  }, true);
})();
